import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ManageCode.css';
import toast, { Toaster } from 'react-hot-toast';
import { useApi } from '../ApiContext';

const ManageCode = () => {
    const { API_BASE_URL } = useApi();
    
    const USER_CODES_API = `${API_BASE_URL}/user-codes`;
    const CODE_API = `${API_BASE_URL}/code`;
    const CODE_ACTION_API = (action) => `${CODE_API}/${action}`;

    const [searchCode, setSearchCode] = useState('');
    const [userFound, setUserFound] = useState(null);
    const [loading, setLoading] = useState(false);
    
    const [showPopup, setShowPopup] = useState(false);
    const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
    const [userCodes, setUserCodes] = useState([]);
    const [userLoading, setUserLoading] = useState(false);

    const getStatusClass = (status) => {
        switch (status) {
            case 'Used': return 'status used';
            case 'Expired': return 'status expired';
            case 'Unused': return 'status unused';
            default: return 'status unknown';
        }
    }

    const fetchUserCodes = async () => {
        setUserLoading(true);
        try {
            const response = await axios.get(USER_CODES_API);
            setUserCodes(response.data.codes);
        } catch (err) {
            console.error('Error fetching user codes:', err);
            setUserCodes([]);
            toast.error(err.response?.data?.message || 'Could not fetch user codes.');
        } finally {
            setUserLoading(false);
        }
    };

    useEffect(() => {
        fetchUserCodes();
    }, [API_BASE_URL]);

    const handleSearch = async (e) => {
        if (e) e.preventDefault();
        setLoading(true);
        setUserFound(null);
        setShowPopup(false);
        try {
            const response = await axios.post(CODE_API, { code: searchCode });
            if (response.data?.data) {
                setUserFound(response.data.data);
                setShowPopup(true);
            } else {
                toast.error('Code not found.');
            }
        } catch (err) {
            toast.error(err.response?.data?.message || 'Error searching code.');
        } finally {
            setLoading(false);
        }
    };
    
    const handleCodeCardClick = async (codeValue) => {
        setSearchCode(codeValue);
        setLoading(true);
        setUserFound(null);
        setShowPopup(false);
        try {
            const response = await axios.post(CODE_API, { code: codeValue });
            if (response.data?.data) {
                setUserFound(response.data.data);
                setShowPopup(true);
            } else {
                toast.error('Code not found.');
            }
        } catch (err) {
            toast.error(err.response?.data?.message || 'Error searching code.');
        } finally {
            setLoading(false);
        }
    };

    const handleAction = async (action) => {
        if (action === 'delete') {
            setShowConfirmDeleteModal(true);
            return;
        }
        try {
            const res = await axios.post(CODE_ACTION_API(action), { code: searchCode });
            toast.success(res.data.message || `${action} successful`);
            setUserFound(null);
            setShowPopup(false);
            await fetchUserCodes(); 
        } catch (err) {
            toast.error(err.response?.data?.message || 'Action failed.');
        }
    };

    const handleConfirmDelete = async () => {
        try {
            const res = await axios.post(CODE_ACTION_API('delete'), { code: searchCode });
            toast.success(res.data.message || 'Delete successful');
            await fetchUserCodes(); 
            setUserFound(null);
            setShowPopup(false);
            setShowConfirmDeleteModal(false);
            setSearchCode(''); 
        } catch (err) {
            toast.error(err.response?.data?.message || 'Deletion failed.');
            setShowConfirmDeleteModal(false);
        }
    };

    return (
        <div className="manage-order-container">
            <Toaster />
            
            <form onSubmit={handleSearch} className="search-form">
                <input type="text" placeholder="Enter a single code..." value={searchCode} onChange={(e) => setSearchCode(e.target.value)} />
                <button type="submit" disabled={loading}>{loading ? 'Searching...' : 'Search'}</button>
            </form>
            
            {showPopup && userFound && (
                <div className="modal-overlay">
                    <div className="modal-card">
                        <h3>Code Details</h3>
                        <div className="code-detail">
                            <p><strong>Card Code:</strong> {userFound.card}</p>
                            <p><strong>Duration:</strong> {userFound.duration}</p>
                            <p><strong>Expiration:</strong> {userFound.expiration || 'Not activated'}</p>
                        </div>
                        <div className="action-buttons">
                            <button onClick={() => handleAction('delete')}>Delete</button>
                            <button onClick={() => handleAction('reset')}>Reset</button>
                            <button className="close-btn" onClick={() => setShowPopup(false)}>Close</button>
                        </div>
                    </div>
                </div>
            )}
            
            {showConfirmDeleteModal && (
                <div className="modal-overlay">
                    <div className="modal-card">
                        <h3>Confirm Deletion</h3>
                        <p>Are you sure you want to delete this code?</p>
                        <div className="action-buttons">
                            <button onClick={handleConfirmDelete}>Confirm</button>
                            <button className="close-btn" onClick={() => setShowConfirmDeleteModal(false)}>Cancel</button>
                        </div>
                    </div>
                </div>
            )}

            {userLoading && <p>Loading your codes...</p>}
            
            <div className="user-codes-grid">
                {userCodes.length > 0 ? (
                    userCodes.map((code, index) => (
                        <div key={index} className="manage-code-card" onClick={() => handleCodeCardClick(code.card)}>
                            <div className="product-header">
                                <h3>{code.name}</h3>
                                <p className={getStatusClass(code.status)}>{code.status}</p>
                            </div>
                            <span className="test">{code.card}</span>
                            {/* 🌟 REVISED: Tunjuk Duration yang manusia faham */}
                            <p><strong>Duration:</strong> {code.duration}</p>
                            {code.order_id && <p><strong>Order ID:</strong> {code.order_id}</p>}
                            <p><strong>Expires:</strong> {code.expiration}</p>
                        </div>
                    ))
                ) : (
                    !userLoading && <p>No codes found.</p>
                )}
            </div>
        </div>
    );
};

export default ManageCode;